export default "__VITE_ASSET__Btvc4J9M__"